export default __webpack_public_path__ + "static/media/gallery_07.0d0bd582.jpg";